<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> On-Page </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>
    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-primary text-white rounded p-2">
            <i class="fas fa-sitemap fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">ON-PAGE SEO</h2>
            <!-- <p class="text-muted mb-0 small">
              Analyze and optimize individual pages to clearly express intent,
              satisfy users, and drive conversions.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-play-circle me-1"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
          <!-- <button class="btn btn-dark btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-1"></i> New On-Page Review
          </button> -->
        </div>
      </div>

      <!-- Main Layout -->
      <div class="row">
        <div class="col-lg-12">
          <!-- Filters -->
          <div class="row mb-0 px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end mt-2 pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>
            <!-- Location filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Location</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLocation"
              >
                <option *ngFor="let loc of locations" [value]="loc.value">
                  {{ loc.label }}
                </option>
              </select>
            </div>

            <!-- Universe filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option value="">All Universes</option>
                <option *ngFor="let uni of universes" [value]="uni.value">
                  {{ uni.label }}
                </option>
              </select>
            </div>

            <!-- Category filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Category</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingCategory"
              >
                <option value="">All Categories</option>
                <option *ngFor="let cat of categories" [value]="cat.value">
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-darsk mb-1 d-block"
                >Target URL</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All URLs</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Page Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Intent Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-12"> -->
      <!-- Statistics -->
      <div class="row">
        <div class="col-12">
          <!-- <div
                class="card w-100 shadow-sm border-0 card-statistics"
                style="background-color: #f1f5f9"
              > -->
          <div
            class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
          >
            <!-- Stat 1 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-blue me-3">
                    <i class="material-icons">sell</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>URLS REVIEWED</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.urlsReviewed.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.urlsReviewed.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.urlsReviewed.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.urlsReviewed.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 2 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-green me-3">
                    <i class="material-icons">search</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>NEEDS OPTIMIZATION</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.needsOptimization.value }}
                    </h3>
                    <div class="small fw-medium text-success">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_upward</span
                      >
                      {{ stats.needsOptimization.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 3 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-orange me-3">
                    <i class="material-icons">find_replace</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>READY</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.readyToMap.value }}
                    </h3>
                    <div class="small fw-medium text-danger">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_downward</span
                      >
                      {{ stats.readyToMap.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 4 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-red me-3">
                    <i class="material-icons">gps_off</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>CRITICAL GAPS</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.mappingGaps.value }}
                    </h3>
                    <div class="small fw-medium text-danger">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_downward</span
                      >
                      {{ stats.mappingGaps.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 5 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-purple me-3">
                    <i class="material-icons">plagiarism</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>CONTENT NEEDS</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.contentNeeds.value }}
                    </h3>
                    <div class="small fw-medium text-muted">
                      {{ stats.contentNeeds.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <!-- </div>
      </div> -->
      <div class="row">
        <div class="col-lg-12 d-flex">
          <!-- Left Column (Table) -->
          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-3 pl-3">
                <strong>ON-PAGE REVIEW QUEUE</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item">
                  <a class="nav-link active fw-bold" href="javascript:void(0)"
                    ><strong>All URLs</strong>
                    <span
                      class="badge bg-light border border-info text-dark ms-1"
                      >106</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Needs Work</strong>
                    <span
                      class="badge bg-light border border-primary text-primary ms-1"
                      >64</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Critical Gaps</strong>
                    <span
                      class="badge bg-light border border-info text-info ms-1"
                      >16</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Ready</strong>
                    <span
                      class="badge bg-light border border-secondary text-secondary ms-1"
                      >86</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Recently Reviewed</strong>
                    <span
                      class="badge bg-light border border-danger text-danger ms-1"
                      >20</span
                    ></a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th class="ps-3 kw-url-mapping-header">
                        <strong>URL</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>MAPPED INTENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>TITLE ALIGNMENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>H1 ALIGNMENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>CONTENT DEPTH</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>CTA ALIGNMENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>FAQ OPPORTUNITY</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="pe-3 text-end kw-url-mapping-header">
                        <strong>ACTION</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let review of reviewsQueue"
                      [class.table-active]="
                        review.url === selectedMapping.keyword
                      "
                      (click)="selectMapping(review)"
                      style="cursor: pointer"
                    >
                      <td class="ps-3 fw-medium text-primary">
                        <a href="javascript:void(0)">{{ review.url }}</a>
                      </td>
                      <td>{{ review.mappedIntent }}</td>
                      <td>
                        <span
                          [ngClass]="{
                            'text-danger fw-medium':
                              review.titleAlignment === 'Weak',
                            'text-success fw-medium':
                              review.titleAlignment === 'Good',
                            'text-warning fw-medium':
                              review.titleAlignment === 'Moderate',
                          }"
                          >{{ review.titleAlignment }}</span
                        >
                      </td>
                      <td>
                        <span
                          [ngClass]="{
                            'text-danger fw-medium':
                              review.h1Alignment === 'Weak',
                            'text-success fw-medium':
                              review.h1Alignment === 'Good',
                            'text-warning fw-medium':
                              review.h1Alignment === 'Moderate',
                          }"
                          >{{ review.h1Alignment }}</span
                        >
                      </td>
                      <td>
                        <span
                          [ngClass]="{
                            'text-danger fw-medium':
                              review.contentDepth === 'Weak',
                            'text-success fw-medium':
                              review.contentDepth === 'Strong',
                            'text-warning fw-medium':
                              review.contentDepth === 'Moderate',
                          }"
                          >{{ review.contentDepth }}</span
                        >
                      </td>
                      <td>
                        <span
                          [ngClass]="{
                            'text-danger fw-medium':
                              review.ctaAlignment === 'Weak',
                            'text-success fw-medium':
                              review.ctaAlignment === 'Good',
                            'text-warning fw-medium':
                              review.ctaAlignment === 'Moderate',
                          }"
                          >{{ review.ctaAlignment }}</span
                        >
                      </td>
                      <td>
                        <span class="text-dark">{{
                          review.faqOpportunity
                        }}</span>
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          [ngClass]="{
                            'bg-success-light text-success':
                              review.status === 'Ready',
                            'bg-warning-light text-warning':
                              review.status === 'Needs Work',
                            'bg-danger-light text-danger':
                              review.status === 'Critical Gap',
                            'bg-primary-light text-primary border border-primary bg-white':
                              review.status === 'Review',
                          }"
                        >
                          {{ review.status }}
                        </span>
                      </td>
                      <td class="pe-3 text-end">
                        <a
                          href="javascript:void(0)"
                          class="text-primary text-decoration-none fw-medium"
                          style="font-size: 0.8rem"
                        >
                          {{ review.recommendedAction }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div
                class="d-flex justify-content-between align-items-center p-3 border-top bg-light"
              >
                <span class="small text-muted"
                  >Showing 1 to 8 of 742 results</span
                >
                <div class="d-flex gap-1">
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button class="btn btn-sm btn-dark px-2">1</button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    2
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    3
                  </button>
                  <span class="px-2">...</span>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    93
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm w-auto">
                  <option>10 / page</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 d-flex">
          <!-- Selected Mapping Review -->
          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-0 pt-3 p-2"
            >
              <h4 class="fw-bold text-uppercase mb-0 pl-2">
                <strong>SELECTED URL REVIEW</strong>
              </h4>
            </div>
            <div class="card-body pt-2 pl-2">
              <div class="d-flex align-items-center mb-2 pl-2">
                <h5 class="text-primary mb-0 me-2">
                  {{ selectedMapping.keyword }}
                </h5>
                <span
                  class="badge bg-success-light text-success text-transformNone"
                  >{{ selectedMapping.status }}</span
                >
              </div>
              <div class="d-flex gap-1 mb-4"></div>

              <div class="d-flex align-items-center mb-2 pl-2">
                <h5 class="text-dark mb-0 me-2">Mapped Intent:</h5>
                <h5 class="text-dark text-transformNone mb-0">
                  Miami Legal Courier
                </h5>
                <span
                  class="badge bg-primary-light text-primary text-transformNone"
                  *ngFor="let tag of selectedMapping.tags"
                  >{{ tag }}</span
                >
              </div>

              <div class="table-responsive custom-scroll-x">
                <table
                  class="table table-sm table-borderless small mb-4 border-top border-bottom border-info"
                >
                  <tbody>
                    <tr>
                      <td class="text-dark w-50">Semantic Coverage</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.semanticCoverage }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Intent Prominence</td>
                      <td class="text-end">
                        <span
                          class="badge bg-warning-light text-warning text-transformNone"
                          >{{ selectedMapping.architecturalFit }}</span
                        >
                      </td>
                    </tr>

                    <tr>
                      <td class="text-dark w-50">Title Alignment</td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                          >{{ selectedMapping.explicitIntentSupport }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Meta Description</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.cannibalizationRisk }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">H1 Alignment</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.technicalEligibility }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Content Gaps</td>
                      <td class="text-end">
                        <h5 class="text-dark text-transformNone">
                          {{ selectedMapping.contentDepth }}
                        </h5>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">CTA Alignment</td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                        >
                          Weak
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">FAQ Opportunity</td>
                      <td class="text-end">
                        <h5 class="text-dark text-transformNone">
                          {{ selectedMapping.mappingDivergence }}
                        </h5>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Schema Relevance</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                        >
                          Good
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Over-Optimization Risk</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                        >
                          Low
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="bg-light p-2 rounded">
                <h5 class="small fw-bold text-uppercase mb-2 ai-rationale">
                  AI RATIONALE
                </h5>
                <p class="small text-muted mb-0 lh-sm">
                  {{ selectedMapping.aiRationale }}
                </p>
                <br />
                <p class="small text-muted mb-0 lh-sm">
                  Review Origin: AI detected
                </p>
                <p class="small text-muted mb-0 lh-sm">
                  Last Review: May 18, 2025
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column (Sidebar) -->
        <div class="col-lg-4 d-flex pl-0">
          <!-- Recent Mapping Activity -->
          <div class="card shadow-sm flex-grow-1 mt-0 mb-4">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0">
                <strong>RECENT ON-PAGE ACTIVITY</strong>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all activity <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-2 mt-3 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-muted text-uppercase">
                  <tr>
                    <th class="ps-3 header-signals-activity">ACTION</th>
                    <th class="header-signals-activity">DETAILS</th>
                    <th class="header-signals-activity">BY</th>
                    <th class="header-signals-activity">DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let a of recentActivity" class="border-bottom">
                    <td class="ps-3 text-nowrap fw-medium">{{ a.action }}</td>
                    <td class="text-muted" style="font-size: 0.75rem">
                      {{ a.details }}
                    </td>
                    <td class="text-center">{{ a.by }}</td>
                    <td class="text-muted text-nowrap">{{ a.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 d-flex">
          <!-- Bottom sections inside Left Column -->
          <div class="row row-cols-1 row-cols-md-3 g-3 mb-4 flex-grow-1">
            <!-- High-Value Keywords -->
            <div class="col-4">
              <div class="card shadow-sm h-100 mt-0">
                <div class="card-header bg-white border-bottom-0 pb-0">
                  <h4 class="fw-bold text-uppercase small mb-3">
                    <strong>RECOMMENDED ON-PAGE ACTIONS</strong> (4)
                  </h4>
                </div>
                <div class="card-body p-0 custom-scroll-x">
                  <table class="table table-sm table-borderless small mb-0">
                    <thead class="text-uppercase">
                      <tr>
                        <th class="ps-3 head-table">
                          <strong>ACTION</strong>
                        </th>
                        <th class="head-table">
                          <strong>TYPE</strong>
                        </th>
                        <th class="head-table">
                          <strong>IMPACT</strong>
                        </th>
                        <th class="head-table">
                          <strong>CONFIDENCE</strong>
                        </th>
                        <th class="head-table">
                          <strong>STATUS</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let hw of recommendedActions">
                        <td
                          class="ps-3 fw-medium text-truncate url-cell"
                          style="max-width: 120px; cursor: pointer;"
                          (click)="showModal('Full Action', hw.action)"
                          title="Click to view full action"
                        >
                          {{ hw.action | slice:0:10 }}{{ hw.action.length > 10 ? '...' : '' }}
                        </td>
                        <td class="text-center">{{ hw.type }}</td>
                        <td class="text-center">
                          <span
                            class="text-dark fw-medium"
                            style="font-size: 0.7rem"
                            >{{ hw.impact }}</span
                          >
                        </td>
                        <td class="text-center">
                          <span class="fw-bold">{{ hw.confidence }}</span>
                        </td>
                        <td>
                          <span
                            class="fw-medium"
                            [ngClass]="{
                              'text-primary': hw.status === 'Proposed',
                              'text-warning bg-warning-light px-2 py-1 rounded':
                                hw.status === 'Content Need',
                            }"
                            style="font-size: 0.7rem"
                            >{{ hw.status }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-end p-2 border-top">
                    <a href="#" class="small text-decoration-none text-primary"
                      >View all actions <i class="fas fa-arrow-right"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cannibalization Issues -->
            <div class="col-4 pl-0">
              <div class="card shadow-sm h-100 mt-0">
                <div class="card-header bg-white border-bottom-0 pb-0">
                  <h4 class="fw-bold text-uppercase small mb-3">
                    <strong>CONTENT NEEDS</strong>(2)
                  </h4>
                </div>
                <div class="card-body p-0 custom-scroll-x">
                  <table class="table table-sm table-borderless small mb-0">
                    <thead class="text-uppercase">
                      <tr>
                        <th class="ps-3 head-table">
                          <strong>NEED</strong>
                        </th>
                        <th class="head-table">
                          <strong>DETAILS</strong>
                        </th>
                        <th class="head-table">
                          <strong>PRIORITY</strong>
                        </th>
                        <th class="head-table"><strong>ACTION</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let ci of contentNeedsList">
                        <td
                          class="ps-3 text-truncate"
                          style="max-width: 120px"
                          title="{{ ci.need }}"
                        >
                          {{ ci.need }}
                        </td>
                        <td
                          class=""
                          title="{{ ci.details }}"
                          style="font-size: 0.75rem; white-space: normal"
                        >
                          {{ ci.details }}
                        </td>
                        <td
                          class="text-center text-danger fw-medium"
                          style="font-size: 0.75rem"
                        >
                          <span
                            [ngClass]="{
                              'text-danger': ci.priority === 'High',
                              'text-warning': ci.priority === 'Medium',
                            }"
                            >{{ ci.priority }}</span
                          >
                        </td>
                        <td>
                          <a
                            href="#"
                            class="text-primary fw-medium text-decoration-none"
                            style="font-size: 0.75rem"
                            >{{ ci.action }}</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-end p-2 border-top">
                    <a href="#" class="small text-decoration-none text-primary"
                      >View all content needs <i class="fas fa-arrow-right"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Orphan Pages -->
            <div class="col-4 pl-0">
              <div class="card shadow-sm h-100 mt-0">
                <div class="card-header bg-white border-bottom-0 pb-0">
                  <h4 class="fw-bold text-uppercase small mb-3">
                    <strong>SIGNALS SENT</strong>(3)
                  </h4>
                </div>
                <div class="card-body p-0 custom-scroll-x">
                  <table class="table table-sm table-borderless small mb-0">
                    <thead class="text-uppercase">
                      <tr>
                        <th class="ps-3 head-table"><strong>SIGNAL</strong></th>
                        <th class="head-table"><strong>TO</strong></th>
                        <th class="head-table"><strong>STATUS</strong></th>
                        <th class="head-table"><strong>DATE</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let op of signalsSentList">
                        <td
                          class="ps-3 text-truncate text-wrap"
                          style="max-width: 120px; font-size: 0.75rem"
                          title="{{ op.signal }}"
                        >
                          {{ op.signal }}
                        </td>
                        <td class="text-center" style="font-size: 0.75rem">
                          {{ op.to }}
                        </td>
                        <td class="text-center">
                          <span
                            class="badge rounded-pill"
                            [ngClass]="{
                              'bg-success-light text-success':
                                op.status === 'Sent',
                              'bg-warning-light text-warning':
                                op.status === 'Open',
                              'bg-primary-light text-primary':
                                op.status === 'Monitoring',
                            }"
                            >{{ op.status }}</span
                          >
                        </td>
                        <td
                          class="text-end fw-medium"
                          style="font-size: 0.7rem"
                        >
                          {{ op.date }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-end p-2 border-top">
                    <a href="#" class="small text-decoration-none text-primary"
                      >View all signals <i class="fas fa-arrow-right"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!-- Mapping Decision Center -->
          <div class="card shadow-sm mt-0" style="border: 1px solid #ffcdd2">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 px-3 d-flex align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0 me-3">
                <strong>ON-PAGE ACTION CENTER</strong>
              </h4>
              <span class="badge bg-success-light text-success"
                >1 action selected</span
              >
            </div>
            <div class="card-body container-fluid pl-0 pr-0">
              <div class="custom-scroll-x pb-2">
                <!-- <div
                  class="d-flex align-items-stretch flex-nowrap mx-0 gap-3"
                  style="min-width: 1100px"
                > -->
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- SELECTED ACTION -->
                    <div class="col">
                      <h6
                        class="small fw-bold text-dark mb-3 text-uppercase"
                        style="font-size: 0.7rem; letter-spacing: 0.5px"
                      >
                        <strong>SELECTED ACTION</strong>
                      </h6>
                      <p class="fw-bold text-dark text-nowrap font-size12">
                        <strong>Strengthen Page Title</strong>
                      </p>

                      <div class="d-flex align-items-center">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>TARGET URL</strong>
                        </h6>
                        <span class="small fw-medium mb-3 ml-3"
                          >/legal-services/</span
                        >
                      </div>
                      <div class="d-flex align-items-center">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>ELEMENT</strong>
                        </h6>
                        <span class="small fw-medium mb-3 ml-3">Title</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          <strong>DECISION ORIGIN</strong>
                        </h6>
                        <span class="small fw-medium mb-3 ml-3"
                          >AI Detected</span
                        >
                      </div>
                    </div>

                    <!-- CURRENT -->
                    <div class="col border rounded bg-white">
                      <h6
                        class="small fw-bold text-dark mb-3 text-uppercase"
                        style="font-size: 0.75rem"
                      >
                        <strong>CURRENT</strong>
                      </h6>
                      <p class="small mb-3 text-dark fw-medium">
                        Legal Services | Courier & Beyond
                      </p>
                      <p class="small text-muted mb-3">Length: 30 characters</p>
                      <div class="d-flex align-items-center">
                        <span class="small text-muted me-2"
                          >Intent clarity:</span
                        >
                        <span class="badge bg-danger-light text-danger"
                          >Low</span
                        >
                      </div>
                    </div>

                    <!-- ARROW -->
                    <div
                      class="d-flex align-items-center justify-content-center px-1"
                    >
                      <i class="fas fa-arrow-right text-muted"></i>
                    </div>

                    <!-- PROPOSED -->
                    <div
                      class="col-auto border rounded"
                      style="
                        background-color: #f8fff9;
                        border-color: #e6f4ea !important;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-3 text-uppercase"
                        style="font-size: 0.75rem"
                      >
                        <strong>PROPOSED</strong>
                      </h6>
                      <p class="small mb-3 text-dark fw-medium">
                        Legal Courier Services in Miami | Courier & Beyond
                      </p>
                      <p class="small text-muted mb-3">Length: 55 characters</p>
                      <div class="d-flex align-items-center">
                        <span class="small text-muted me-2"
                          >Intent clarity:</span
                        >
                        <span class="badge bg-success-light text-success"
                          >High</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- AI RECOMMENDATION -->
                    <div
                      class="col border-start ps-4"
                      style="width: 320px"
                    >
                      <h6
                        class="small fw-bold text-primary mb-3 text-uppercase"
                        style="font-size: 0.75rem; font-weight: bold"
                      >
                        AI RECOMMENDATION
                      </h6>
                      <p
                        class="small text-muted mb-3 lh-sm"
                        style="font-size: 0.8rem"
                      >
                        The current title does not explicitly express the Miami
                        legal courier intent. The proposed title strengthens
                        intent clarity while remaining natural and within
                        optimal length.
                      </p>
                      <a
                        href="javascript:void(0)"
                        class="small text-primary text-decoration-none fw-medium"
                        >View full AI rationale
                        <i class="fas fa-arrow-right ms-1"></i
                      ></a>
                    </div>

                    <!-- Confidence / Risk / Mode -->
                    <div class="col-auto border-start ps-4 ms-2 d-flex gap-4">
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          AI CONFIDENCE
                        </h6>
                        <div class="progress-circle mx-auto" data-perc="94">
                          <span class="text-success fw-bold fs-5">94%</span>
                        </div>
                      </div>
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          RISK LEVEL
                        </h6>
                        <span
                          class="badge bg-success-light text-success px-3 py-1 mt-2"
                          >Low</span
                        >
                      </div>
                      <div class="text-center pr-2">
                        <h6
                          class="small fw-bold text-dark mb-3 text-uppercase"
                          style="
                            font-size: 0.7rem;
                            letter-spacing: 0.5px;
                            font-weight: bold;
                          "
                        >
                          EXECUTION MODE
                        </h6>
                        <div
                          class="badge bg-warning-light text-warning text-wrap mx-auto py-2 px-3 mt-1"
                          style="width: 120px; line-height: 1.3"
                        >
                          Human Approval Required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Buttons Row -->
              <div
                class="d-flex gap-3 justify-content-between mt-4 custom-scroll-x pb-2 flex-nowrap"
                style="min-width: 100%"
              >
                <div class="d-flex gap-2 flex-nowrap m-auto">
                  <button
                    class="btn btn-success fw-medium flex-fill btn-desicion-mapping"
                    (click)="approveMapping()"
                    [disabled]="saving"
                  >
                    <i class="fas fa-check me-2"></i> Approve & Implement
                  </button>
                  <button
                    class="btn btn-outline-secondary fw-medium flex-fill btn-desicion-mapping"
                  >
                    <i class="fas fa-pencil-alt me-2"></i> Edit Action
                  </button>
                  <button
                    class="btn btn-outline-primary border border-primary fw-medium flex-fill btn-desicion-mapping"
                    style="color: #a855f7; background-color: white"
                  >
                    <i class="fas fa-magic me-2"></i> Ask AI to Reconsider
                  </button>
                  <button
                    class="btn btn-outline-danger border border-danger fw-medium flex-fill text-danger bg-white btn-desicion-mapping"
                    (click)="rejectMapping()"
                    [disabled]="saving"
                  >
                    <i class="fas fa-shield-alt me-2 text-danger"></i> Reject
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary fw-medium w-100 text-start d-flex justify-content-between align-items-center bg-white dropdown-toggle btn-desicion-mapping"
                    data-bs-toggle="dropdown"
                  >
                    <span
                      ><i class="fas fa-paper-plane me-2 text-primary"></i>
                      Create Signal</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="mt-3 text-muted small d-flex align-items-center">
        <i class="fas fa-info-circle me-2"></i> On-Page optimizes the page. URL
        Mapping assigns intent ownership. Request Intake manages production
        needs.
      </div> -->
    </div>

    <div
      *ngIf="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
